import React from 'react';
import { Tick } from '~/components/elements/Icon';

export const BestPrice = (props) => {
    
    const { accessory, description, heading, image, imageDescription, imageHeading, learnMoreButton, sectionClass, subHeading } = props;

    return (
        <section className="bg-[#f6f9ff] pb-[7rem] px-4 md:px-10 text-center font-sans">
            <div className="main-content-section max-w-6xl mx-auto">
                <div className="max-w-3xl mx-auto">
                    <h4 className='subHeading text-[#2664EB] font-semibold uppercase tracking-wide mb-2'>{subHeading}</h4>
                    <h2 className="text-blue uppercase tracking-wide font-semibold text-sm mb-2 heading">
                        {heading}
                    </h2>

                    <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-10 font-manrope pt-content">
                        {description}
                    </p>

                    <div className="bg-white rounded-3xl p-6 max-w-sm mx-auto pt-image">
                        <img src={image.localFile.publicURL} alt="Phonak Audéo Infinio" className="mx-auto mb-4 w-[148px] h-[148px]" />
                        <h3 className="font-semibold text-gray-900 text-lg mb-1 font-manrope pt-image-heading">{imageHeading}</h3>
                        <p className="text-gray-500 text-sm font-manrope pt-image-description">
                            {imageDescription}
                        </p>
                        <a href={learnMoreButton.url} target={learnMoreButton.target}>
                        <button className="pt-button bg-blue text-white px-5 py-2 rounded-full font-medium text-sm mb-6 hover:bg-blue-600 transition-all inline-flex items-center justify-center gap-1">
                            {learnMoreButton?.title}
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" className="inline-block">
                            <image
                                href="https://d9hhrg4mnvzow.cloudfront.net/dallas.yeshearing.com/15kwuyr-phoneleft.png"
                                width="20"
                                height="20"
                            />
                            </svg>
</button>
                        </a>

                        <ul className="space-y-3 text-left ">
                            {accessory.map((data, index) => (
                            <li key={data.accessory} className="pt-accessory flex gap-2 text-gray-700 text-sm">
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    backgroundColor: "#4CAF50", // Green background
                                    color: "white",            // White tick
                                    borderRadius: "50px",       // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "20px",
                                    height: "20px",
                                    padding: "5px"
                                }}>
                                    <Tick />
                                </span>
                                {data.accessory}
                            </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
      
  );
};
